import { GET_DATA_USER_MENU_SUCCEEDED, REQUERT_DATA_PERMISSION_FAILED } from "../actions/actionsTypes";

const userMenuReducer = (DataUserMenu = [], actions) => {
    switch (actions.type) {
        case GET_DATA_USER_MENU_SUCCEEDED:
            if(Object.keys(actions.DataUserMenu).length > 0){
                return {...DataUserMenu, DataUserMenu: actions.DataUserMenu};
            }
            else{
                return {...DataUserMenu, DataUserMenu: []};
            }
        case REQUERT_DATA_PERMISSION_FAILED:
            return {...DataUserMenu, DataUserMenu:[]};
        default:
        return DataUserMenu;
    }
}

export default userMenuReducer;